import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { authSession } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Processes #session_id=... returned by Emergent Google Auth, then redirects to /admin.
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sid = params.get("session_id");
    const dest = location.pathname && location.pathname !== "/" ? location.pathname : "/admin";
    if (!sid) { navigate(dest, { replace: true }); return; }
    authSession(sid)
      .then((u) => { setUser(u); window.history.replaceState({}, "", dest); navigate(dest, { replace: true }); })
      .catch(() => { window.history.replaceState({}, "", dest); navigate(dest, { replace: true }); });
  }, [location.hash, location.pathname, navigate, setUser]);

  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <p className="animate-pulse font-display text-xl text-navy">Signing you in…</p>
    </div>
  );
}
